import { render } from "./decorate.vue?vue&type=template&id=18f75630&scoped=true"
import script from "./decorate.vue?vue&type=script&lang=js"
export * from "./decorate.vue?vue&type=script&lang=js"

import "./decorate.vue?vue&type=style&index=0&id=18f75630&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f75630"],['__file',"src/views/wap/decorate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18f75630"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18f75630', __exports__)) {
    console.log('reload')
    api.reload('18f75630', __exports__)
  }
  
  module.hot.accept("./decorate.vue?vue&type=template&id=18f75630&scoped=true", () => {
    console.log('re-render')
    api.rerender('18f75630', render)
  })

}


export default __exports__